// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { getErrorSelector } from '@tcp/core/src/utils/utils.extension';
import {
  ADDEDITADDRESS_REDUCER_KEY,
  LOGINPAGE_REDUCER_KEY,
} from '../../../../../constants/reducer.constants';
import { getAddressListState } from '../../../../features/account/AddressBook/container/AddressBook.selectors';
import { getLabelFromCopyOrFromTranslation } from '../../../../../utils/labels/labelUtilty';
import globalAddEditAddressLabels, {
  GLOBAL_ADD_EDIT_ADDRESS_LABELS,
} from '../../../../../utils/labels/globalAddEditAddress.labels';

export const getAddressResponse = (state) => {
  return state[ADDEDITADDRESS_REDUCER_KEY];
};

export const getUserEmail = (state) => {
  return state[LOGINPAGE_REDUCER_KEY] && state[LOGINPAGE_REDUCER_KEY].get('email1');
};

export const getAddressId = (state, props) => {
  return (props.router && props.router.query && props.router.query.addressId) || false;
};

export const getAddressById = createSelector(
  [getAddressListState, getAddressId],
  (addressList, addressId) => {
    return addressId ? addressList.find((address) => address.addressId === addressId) : null;
  }
);

export const getAddEditErrorResponse = (state) => {
  return state[ADDEDITADDRESS_REDUCER_KEY] && state[ADDEDITADDRESS_REDUCER_KEY].get('error');
};

export const getshowNotification = createSelector(
  getAddressResponse,
  (resp) => resp && resp.get('showNotification')
);

export const getAddEditErrorMessage = createSelector(getAddEditErrorResponse, (state) => {
  const addEditLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_ADD_EDIT_ADDRESS_LABELS,
    globalAddEditAddressLabels
  );
  return getErrorSelector(state, addEditLabels, 'lbl_addEditAddress_error');
});

export const getAddressFormSubmitErrors = (state) =>
  state.form && state.form.AddressForm && state.form.AddressForm.submitErrors;
